import React from 'react'
import styled from '@emotion/styled'
import { BreakPoint, Styles } from 'src/components/shared/CssValues'
import HeadingBorder from 'src/components/atoms/HeadingBorder'
import ContentsWrapper from 'src/components/atoms/wrappers/ContentsWrapper'
import HeadTitle from 'src/components/atoms/HeadTitle'
import resaleImg from 'src/images/partner/resale.png'
import brokeragesalesImg from 'src/images/partner/brokerage-sales.png'

export const PartnerAbout= () => {
    return (
        <Container>
            <ContentsWrapper>
                <HeadingBorder heading="ABOUT" />
                <HeadTitle>パートナー制度について</HeadTitle>
                <ColumnWrapper>
                    <Column>
                        <VectorImage src={brokeragesalesImg} alt="販売仲介→【顧客紹介パートナー】" />
                        <Title as="h3">
                            販売仲介→【顧客紹介パートナー】
                        </Title>
                    </Column>
                    <Column>
                        <VectorImage src={resaleImg} alt="再販売→【再販売パートナー】" />
                        <Title as="h3">
                            再販売→【再販売パートナー】
                        </Title>
                    </Column>
                </ColumnWrapper>
            </ContentsWrapper>
        </Container>
    )
}

const Container = styled.div`
    background-color: ${Styles.color.primary[200]};
    padding: ${Styles.spacing[11]} 0;
`

const ColumnWrapper = styled.div`
    padding: 0 0 ${Styles.spacing[11]};
    max-width: 990px;
    margin: auto;
    display: flex;
    flex-direction: column;
    gap: ${Styles.spacing[14]};
    @media screen and (min-width: ${BreakPoint.TABLET}) {
        padding: 0 50px ${Styles.spacing[13]};
        flex-direction: row;
    }
`

const Column = styled.div`
    text-align: center;
`

const VectorImage = styled.img`
    max-width: 40%;
    height: auto;
    align-self: flex-start;
    margin: calc(${Styles.spacing[4]} * -1) 0 0 calc(${Styles.spacing[4]} * -1);
    @media screen and (min-width: ${BreakPoint.MOBILE}) {
        margin: 0 0 0 calc(${Styles.spacing[4]} * -1);
        max-width: 80%;
        padding-bottom: 20px;
    }
    @media screen and (min-width: ${BreakPoint.TABLET}) {
        margin: 0;
        max-width: 100%;
    }
`

const Title = styled.div`
    color: ${Styles.color.primary[400]};
    font-size: ${Styles.fontSize[400]};
    font-weight: ${Styles.fontWeight.bold};
    line-height: ${Styles.lineHeight[400]};
    letter-spacing: ${Styles.letterSpacing[400]};
    
    @media screen and (min-width: ${BreakPoint.TABLET}) {
        font-size: ${Styles.fontSize[500]};
        flex: 1;
        min-width: 0;
        align-items: center;
        justify-content: center;
        margin-top: 30px;
    }
`
